import { createRoute } from "@tanstack/solid-router";
import { adminRoute } from "./admin";
import { EmailCampaignManager } from "@/features/admin/components/email-campaign-manager";
import { PageContainer } from "@fleet/ui";

function AdminEmailCampaignsPage() {
  return (
    <PageContainer maxWidth="6xl">
      <EmailCampaignManager />
    </PageContainer>
  );
}

interface AdminEmailCampaignsSearch {
  /** Open "New campaign" form (`?new=1`). */
  new?: "1";
}

export const adminEmailCampaignsRoute = createRoute({
  getParentRoute: () => adminRoute,
  path: "/email/campaigns",
  validateSearch: (search: Record<string, unknown>): AdminEmailCampaignsSearch =>
    // CC-18: also accepts the NUMBER 1 (TanStack JSON-parses `?new=1` to number 1).
    search.new === "1" || search.new === 1 ? { new: "1" } : {},
  component: AdminEmailCampaignsPage,
});
